import React from 'react';
import { content } from '../data/content';
import { motion } from 'framer-motion';
import Button from '../components/Button';
import { Ship, Rocket, Target, ArrowRight } from 'lucide-react';

const icons = {
  Shield: Ship,
  Rocket: Rocket,
  Target: Target,
};

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 -z-10 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl opacity-50" />
      <div className="absolute top-1/4 -left-20 -z-10 w-[400px] h-[400px] bg-accent-purple/5 rounded-full blur-3xl opacity-50" />

      <div className="container-custom">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl lg:text-7xl font-display font-bold leading-tight mb-8"
          >
            {content.hero.headingPart1}
            <span className="gradient-text-teal">{content.hero.headingHighlightTeal}</span>
            {content.hero.headingPart2}
            <span className="gradient-text-purple">{content.hero.headingHighlightPurple}</span>
          </motion.h1>

          {/* CTA Cards Row */}
          {/* <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="grid md:grid-cols-2 gap-6 mb-12"
          >
            <div className="p-8 rounded-2xl border border-navy/5 bg-white shadow-sm hover:shadow-md transition-all text-left group">
              <h3 className="text-primary font-bold text-xl mb-2 flex items-center gap-2">
                {content.hero.subheadingStyle1} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </h3>
              <p className="text-navy/60 font-medium">
                {content.hero.subheadingDesc1}
              </p>
              <Button variant="primary" className="mt-6 w-fit py-2">
                {content.hero.cta1}
              </Button>
            </div>

            <div className="p-8 rounded-2xl border border-navy/5 bg-white shadow-sm hover:shadow-md transition-all text-left group">
              <h3 className="text-navy font-bold text-xl mb-2 flex items-center gap-2">
                {content.hero.subheadingStyle2} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </h3>
              <p className="text-navy/60 font-medium">
                {content.hero.subheadingDesc2}
              </p>
              <Button variant="primary" className="mt-6 w-fit py-2 text-navy border-navy/20 hover:bg-navy/5">
                {content.hero.cta2}
              </Button>
            </div>
          </motion.div> */}
        </div>

        {/* Hero Image Section */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4 }}
          className="relative rounded-3xl overflow-hidden shadow-2xl shadow-navy/20 aspect-[21/9] mb-20"
        >
          <img
            src="/hero-team.png"
            alt="Tech Experts"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy/60 to-transparent flex items-end p-8 md:p-12">
            <div className="flex flex-wrap gap-12 text-white">
              {content.valueProps.map((prop, idx) => {
                const Icon = icons[prop.icon] || Target;
                return (
                  <div key={idx} className="flex flex-col gap-2 max-w-[300px]">
                    <Icon className="text-accent-teal mb-2" size={32} />
                    <h4 className="text-xl">{prop.title}</h4>
                    <p className="text-sm text-white/70">{prop.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
